<style  scoped>



</style>

<template>

<header class="c-header u-absolute u-pos-tl u-marg-t-xxl u-fit-w u-align-center u-pad-x-w1of12 u-marg-t-md@sm u-align-left@sm js-header">
    <div class="c-header__container">
      <router-link to="/" class="c-header__logo t-link u-absolute u-pos-x-center u-inline-block u-relative@sm">
        <img src="/static/HeadImages/Logo--salameh--small.png" v-if="'Contact' == $route.name || 'subsidiaries' == $route.name" >
        <img src="/static/HeadImages/Logo-T-Quality-Catering2.png" v-else >
        
      </router-link>
        <!--<router-link to="/" class="c-header__logo t-link u-absolute u-pos-x-center u-inline-block u-relative@sm">
          <img src="../../assets/medias/images/Main-marine-holdings-logo-H-200.png" v-if="color==='clear'">
          <img src="../../assets/medias/images/Main-marine-holdings-logo-H-200.png" v-else>
        </router-link>-->
        <!-- <ul class="c-header__container__list o-list--inline u-pad-t-lg   u-inline-block u-valign-bottom u-marg-b-xs u-hide@sm">
            <li class="c-header__item o-list__item" v-for="(item, index)  in content.nav.links" :class="{'u-marg-r-md':((content.nav.links.length - 1)!=(index))}">
                <router-link :to="item.href"  class="c-header__item__link t-link t-text--base-bold t-text-ls--lg u-uppercase u-color--white" :class="{'u-color--white':color==='clear','u-color--brand-dark':color!='clear'}" active-class="is-active" exact>{{item.label}}</router-link>
            </li>
        </ul>-->
    </div>
</header>

</template>

<script>

export default {
    name: "app-header",
    props: {
        debug: {
            type: Boolean,
            default: !1
        },
        content: {
            type: Object,
            default: function() {}
        },
        color: {
            type: String,
            default: ""
        }
    }
}

</script>
